import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { ISalesOrderModel } from "../models/ISalesOrderModel";
import { SalesOrdersDetailMain } from "./SalesOrdersDetailMain";
import { SalesOrdersDetailProducts } from "./SalesOrdersDetailProducts";
import { SalesOrdersDetailServices } from "./SalesOrdersDetailServices";
import { SalesOrdersDetailAdditional } from "./SalesOrdersDetailAdditional";
import { SalesOrdersDetailFooter } from "./SalesOrdersDetailFooter";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import { useFetchSalesOrder } from "../hooks/fetchDocument";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { NFSecondTab } from "src/components/Shared/NewForms/NFSecondTab";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import { PaymentOffset } from "src/components/Shared/Settlements/PaymentOffset";
interface IProps {
  id?: string;
}

export const SalesOrdersDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ISalesOrderModel>({
    mode: "onTouched"
  });

  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Sales Orders");

  const watchProducts = watch("products");

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchSalesOrder({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.SalesOrders.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFSecondTab title={"Main"} />
        <NFSecondTab title={"Products"} />
        <NFSecondTab title={"Services"} />
        <NFSecondTab title={"Payment offsets"} />
        <NFSecondTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>

        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
          {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
          {/*                              fileName={fileName} setFileName={setFileName}/>*/}
        </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <SalesOrdersDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <SalesOrdersDetailProducts />
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <SalesOrdersDetailServices />
        </NFTabContainer>

        <NFTabContainer index={3} currentIndex={tabIndex}>
          <PaymentOffset selectedPayments={[]} availablePayments={[]} onDoCreditPayment={() => {}} onApplyChanges={() => {}} onRefreshAvailablePayments={async () => {}} />
        </NFTabContainer>

        <NFTabContainer index={4} currentIndex={tabIndex}>
          <SalesOrdersDetailAdditional />
        </NFTabContainer>
      </div>
      <SalesOrdersDetailFooter />
    </FormProvider>
  );
};
